import type { TEmitterType } from '@semios/app-platform-values-helpers-and-types'
import type { TIrrigationPlanData } from '../../types'

export const updateScheduleDuration = (
  data: TIrrigationPlanData[],
  emitterType: TEmitterType,
  zoneId: number,
  date: string,
  newDuration: number,
): TIrrigationPlanData[] =>
  data.map((emitter) => {
    if (emitter.emitterType !== emitterType) return emitter

    const zone = emitter.zones[zoneId]

    if (!zone) return emitter

    return {
      ...emitter,
      zones: {
        ...emitter.zones,
        [zoneId]: {
          ...zone,
          dailyEvents: zone.dailyEvents.map((event) =>
            event.date === date ? { ...event, duration: newDuration } : event,
          ),
        },
      },
    }
  })
